/* STENCIL IMPORTS */
import { Component, Host, h, Prop, State } from "@stencil/core";
/* OTHER LIBRARIES IMPORTS */

import { MercuryBundles, getIconPath } from "@genexus/mercury";

const CSS_BUNDLES: MercuryBundles = [
  "resets/box-sizing",
  // "utils/form",
  // "utils/layout",
  // "utils/typography",
  "components/button",
  // "components/checkbox",
  "components/list-box",
  "components/icon"
];

const VERSION_ICON = getIconPath({
  category: "system",
  name: "version",
  colorType: "on-surface"
});
@Component({
  tag: "gx-ide-test",
  styleUrl: "test.scss",
  shadow: true
})
export class GxIdeTest {
  /* THIS IS A COMPONENT FOR TESTING PURPOSES. DO WHATEVER YOU WANT.*/

  // 1.OWN PROPERTIES //

  /**
   * The component name
   */
  @Prop() readonly name: string;

  // 2. REFERENCE TO ELEMENTS //

  // 3.STATE() VARIABLES //

  @State() filterOn: boolean = true;

  // 4.PUBLIC PROPERTY API | WATCH'S //

  // 5.EVENTS (EMIT) //

  componentWillLoad() {}

  // 6.COMPONENT LIFECYCLE METHODS //

  // 7.LISTENERS //

  // 8.PUBLIC METHODS API //

  // 9.LOCAL METHODS //

  // 10.RENDER() FUNCTION //

  render() {
    return (
      <Host>
        <ch-theme model={CSS_BUNDLES}></ch-theme>

        {/* <span class="giu-static-pill">Hola</span> */}

        <span class="giu-static-pill-icon-and-text giu-static-pill-icon-and-text--version">
          <ch-image class="icon-m" type="mask" src={VERSION_ICON}></ch-image>
          V4.3
        </span>
      </Host>
    );
  }
}
